// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DoubleRightOutlinedSvg from "@ant-design/icons-svg/es/asn/DoubleRightOutlined";
import AntdIcon from '../components/AntdIcon';

var DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DoubleRightOutlinedSvg
  }));
};

DoubleRightOutlined.displayName = 'DoubleRightOutlined';
export default /*#__PURE__*/React.forwardRef(DoubleRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js
// module id = 967
// module chunks = 0